import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import topTitle from '@/components/title';
// import examineModel from './../examineForm/examineModel.vue';
import previewModal from '@/views/claim/demageManage/previewModal.vue';
import { downloadFileFun } from '@/utils/public';
import { streamInfo } from './../../../organization/staffManage/request';
import { getBase64, isImage, isVideo, isPDF } from '@/views/claim/demageManage/utils';
import information from '@/views/claim/customerRecordManage/recordFrom/information.vue';
import { mapState } from 'vuex';
import { policyResource } from '../request.js';
export default {
  // examineModel
  components: {
    topTitle,
    previewModal,
    information
  },
  props: {
    claimsInfo: {
      type: Object,
      default() {
        return {};
      }
    },
    policyNo: {
      type: String,
      default: ''
    },
    policyId: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    examine: {
      type: Boolean,
      default: false
    },
    nodeId: {
      type: String,
      default: '-1'
    },
    nodeType: {
      type: Number,
      default: 0
    },
    status: {
      type: Number,
      default: 0
    }
  },
  computed: {
    ...mapState({
      tag: state => state.user.accountInfo.tag
    }),
    activeUsers() {
      const examine = this.examine;
      return this.claimsInfo.claimsDocument.filter(function (user) {
        if (!examine) {
          if (user.documentUrl.length != 0) {
            return user;
          }
        } else {
          return user;
        }
      });
    }
  },
  data() {
    return {
      previewVisible: false,
      fileList: [],
      previewSrc: '',
      previewPDF: '',
      isPDFShow: false,
      isShow: '',
      currentPreviewIndex: 0,
      examineShow: false,
      policyInfo: null
    };
  },
  mounted() {
    policyResource({
      policyId: this.policyId
    }).then(res => {
      this.policyInfo = res.policyInfo;
    });
  },
  methods: {
    handleDownload(obj) {
      const type2 = obj.format == 'pdf' ? 'application/pdf' : obj.format == 'png' ? 'image/png' : obj.format == 'jpg' ? 'image/jpg' : obj.format == 'jpeg' ? 'image/jpeg' : obj.format == 'gif' ? 'image/gif' : obj.format == 'jfif' ? 'image/jfif' : '';
      streamInfo({
        url: obj.url
      }).then(res => {
        console.log(res);
        downloadFileFun(res, type2, obj.name);
      });
    },
    // 预览处理
    async handlePreview(file, index) {
      isVideo(file.name) ? this.isShow = 'video' : '';
      isImage(file.name) ? this.isShow = 'image' : '';
      this.isPDFShow = isPDF(file.name);
      this.fileList = this.claimsInfo.claimsDocument[index].documentUrl;
      console.log(this.fileList);
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      if (this.isShow === 'image' || this.isShow === 'video') {
        this.previewSrc = file.url || file.preview;
        this.currentPreviewIndex = this.fileList.indexOf(file);
      }
      if (this.isPDFShow) {
        this.previewPDF = file.url || file.response.data.fileTempUrl;
        window.open(this.previewPDF);
        return;
      }
      this.previewVisible = true;
    },
    onSubmit() {
      this.examineShow = true;
      this.$nextTick(() => {
        this.$refs.examineForm.init(this.nodeId, JSON.stringify(this.claimsInfo));
      });
    }
  }
};